import React from "react";

import vorticity_legend from "assets/img/hyperdrive/vorticity_legend.png";
import vorticity1 from "assets/img/hyperdrive/vorticity_or9.gif";
import vorticity2 from "assets/img/hyperdrive/vorticity_fen10.gif";
import vorticity3 from "assets/img/hyperdrive/vorticity_di45.gif";
import zero_tip_clearance from "assets/img/hyperdrive/zero-tip-clearance.png";
import large_tip_clearance from "assets/img/hyperdrive/large-tip-clearance.png";

const TipDriven = ({isMobile}) => {
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        { /* Title */ }
        <h3 className="title" style={{ lineHeight: "150%", fontSize: '2.25em', marginTop: '20px' }}>MagLev Tip-Driven Thrusters</h3>
        
        { /* Text */ }
        <p className="text-center" style={{ color: "white", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
          Open rotors and traditional ducted fans suffer from thrust loss and increased drag due to air leaking around the blade tips, a phenomenon known as tip vortices.
          The MagLev HyperDrive™ directly drives the blade tips, which prevents tip vortices — a crucial advantage that increases rotor performance and reduces noise emissions.
        </p>

        { /* Tip Clearance Images */ }
        <div id="use-cases-section" className="d-flex flex-md-row flex-column justify-content-center align-items-center" style={{ marginTop: '20px'}}>
          {/* Industry Shaft Driven Ducted Fan */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <img src={large_tip_clearance} style={{width:'80%'}} alt="Large tip clearance" />
            <h4 style={{ color: 'white' }}>Conventional Shaft-Driven<br/>Ducted Rotor</h4>
          </div>
          {/* Tip-Driven HyperDrive™ */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <img src={zero_tip_clearance} style={{width:'90%'}} alt="zero-tip-clearance" />
            <h4 style={{ color: 'white' }}>Tip-Driven<br/>HyperDrive™</h4>
          </div>
        </div>

        <br/>

        { /* Text */ }
        <p className="text-center" style={{ color: "white", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
          The high fidelity CFD vorticity results below highlight MagLev HyperDrive™'s key performance improvements.
        </p>

        { /* Vorticity Legend */ }
        <div id="use-cases-section" className="d-flex flex-md-row flex-column justify-content-center align-items-center" style={{ marginTop: '20px'}}>
          <div className="text-center mb-4 mb-md-0" style={{ width: '350px' }}>
            <img src={vorticity_legend} style={{width:'100%'}} alt="Voriticity Legend" />
          </div>
        </div>

        { /* Voriticity GIFs */ }
        <div id="use-cases-section" className="d-flex flex-md-row flex-column justify-content-center align-items-center">
          {/* Unducted Rotor */}
          <div className="text-center mb-4 mb-md-0 align-items-start" style={{ width: '300px' }}>
            <h4 style={{ color: 'white', marginTop: '20px' }}>Unducted Rotor</h4>
            <img src={vorticity1} style={{ width:'95%', marginTop: '20px'}} alt="Unducted Rotor" />
            <p style={{ color: 'white', padding:'8px' }}>
              <br/>
              Fully developed tip vortex:
              <br/>
              Reduces lift and increases noise and power consumption
              {/* Hacking Formatting :) */}
              <br/><br/><br/><br/>
            </p>
          </div>
          {/* Ducted Rotor */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
           <h4 style={{ color: 'white', marginTop: '20px' }}>Ducted Rotor</h4>
            <img src={vorticity2} style={{ width:'95%', marginTop: '20px'}} alt="Ducted Rotor" />
            <p style={{ color: 'white', padding:'8px' }}>
              <br/>
              Duct reduces tip vortex strength:
              <br/>
              Moderately increases lift and reduces power; tip gap leakage remains a source of inefficiency
              <br/><br/>
              <b>
                20-40% more thrust per power
              </b>
            </p>
          </div>
          {/* Ducted HyperDrive */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <h4 style={{ color: 'white', marginTop: '20px' }}>Ducted&nbsp;MagLev&nbsp;HyperDrive&trade;</h4>
            <img src={vorticity3} style={{ width:'95%', marginTop: '20px'}} alt="Ducted HyperDrive" />
            <p style={{ color: 'white', padding:'8px' }}>
              <br/>
              Tip vortex eliminated:
              <br/>
              Maximizes lift from rotor, minimizes losses, and eliminates the tip vortex rotor noise entirely
              <br/><br/>
              <b>
                50-62% more thrust per power
              </b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TipDriven;
